import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { formatServiceLength } from '../../../helpers/serviceLength';
import { ReactComponent as PlayThroughIcon } from '../../../icons/play-through.svg';

import './ServiceLength.scss';

/** One song's length, as a line of small text under its title. Shows nothing without a length. */
const SongLength = ({ seconds, className }) => {
  const { t } = useTranslation();

  if (!seconds) return null;

  return (
    <span className={classNames('SongLength', className)} title={t('services.songLengthTitle')}>
      <PlayThroughIcon aria-hidden="true" />
      {formatServiceLength(seconds)}
    </span>
  );
};

SongLength.propTypes = {
  seconds: PropTypes.number,
  className: PropTypes.string,
};

export default SongLength;
